import { render, staticRenderFns } from "./documents-container.vue?vue&type=template&id=15eb800e"
import script from "./documents-container.vue?vue&type=script&lang=js"
export * from "./documents-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15eb800e')) {
      api.createRecord('15eb800e', component.options)
    } else {
      api.reload('15eb800e', component.options)
    }
    module.hot.accept("./documents-container.vue?vue&type=template&id=15eb800e", function () {
      api.rerender('15eb800e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/documents/components/documents-container.vue"
export default component.exports